import Menu from 'Models/Menu';

export default [
  Menu.userEdit,
  Menu.userDelete,
  Menu.editUserAssets,
  // Menu.userClone,
  // Menu.usersHelp,
];
